import React from 'react';
import { useTranslation } from 'react-i18next';

import RequestRow from './RequestRow.react';
import RequestsPagination from './RequestsPagination.react';

const RequestsList = ({ requests, page, count, promotedRowCount, currency, onOpenRequest, onPageChange }) => {
    const { t } = useTranslation('CashWallet');

    return (
        <div className="cash-wallet-requests-list">
            <div className="cash-wallet-section-title">{t('Requests.AllTitle')}</div>
            <div className="cash-wallet-request-rows">
                {requests.map((request) => (
                    <RequestRow
                        key={request.id}
                        request={request}
                        currency={currency}
                        onOpen={onOpenRequest}
                    />
                ))}
            </div>
            <RequestsPagination
                page={page}
                count={count}
                rowCount={requests.length}
                promotedRowCount={promotedRowCount}
                onChange={onPageChange}
            />
        </div>
    );
};

export default RequestsList;
